module.exports = __webpack_public_path__ + "static/img/img11.a466544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img11.png
// module id = XeAA
// module chunks = 0